
import CardWrapper from "../../../../components/wrapper/card/CardWrapper.tsx";
import { IDeviceStateControllerReturn } from "../../../../../../../commonreact/main/services/devicestate/DeviceStateController.ts";
import { ELng } from "../../../../../../../language/main/LanguageKeysEnums.ts";
import { useTranslation } from "react-i18next";
import CommonCSSSerivce from "../../../../../../../commonreact/main/services/CommonCSSSerivce.ts";
import { appVideos, files, images } from "../../../../../../../Media.ts";
import { Globals } from "../../../../../logic/services/Globals.ts";
import AppCSSService from "../../../../services/AppCSSService.ts";
import AppSVGStore from "../../../../services/AppSVGStore.tsx";
import { VideoController } from "../../../../controllers/VideoController.ts";
import CommonReactGUIElementsFactory from "../../../../../../../commonreact/main/factorys/guielements/CommonReactGUIElementsFactory.tsx";

interface IProps {
  dsc: IDeviceStateControllerReturn;
  ef: CommonReactGUIElementsFactory;
}

export const AndroidAppPromoCard: React.FC<IProps> = (props): JSX.Element => {
  
  const tag = "AndroidAppPromoCard";
  console.log(tag + "START")
  const { t } = useTranslation();
  const vc = VideoController({})
  const r = 1280/720

  const videoHeigth= props.dsc.screenHeight()
  
  return (
    <CardWrapper
    //hideHeaderLine={true}
    dsc={props.dsc}
    header={<h1 className={`mb-0 whitespace-nowrap ${props.dsc.isMobile ? "text-[1.75rem]" : "text-[2.75rem]"}`}>Wheel of Harmonies</h1>}
    //addClassName={`h-[1000px]`}
  >
    <div className="flex flex-col mt-2">
      <div className={`flex ${props.dsc.medium ? "flex-col" : "flex-row"}`}>
        <div className={`${props.dsc.medium ? "w-full" : "w-5/12"} mr-4`}>
          <h2>
            {t(ELng.android_app_desc0.valueOf())}
          </h2>
          <p>
            {t(ELng.android_app_desc1.valueOf())}
          </p>
           <p>
            {t(ELng.android_app_desc2.valueOf())}
          </p>
          <p>
            {t(ELng.android_app_desc3.valueOf())}
          </p>
        </div>

        <div className={`m-auto overflow-hidden
            ${(props.dsc.isMobile) ? "w-full" : (props.dsc.medium ? "w-full" : "w-7/12")}
            ${(props.dsc.isMobileLandscape) ? `h-${videoHeigth}` : ("h-full")}`}>
          <div className={`align-middle relative ${(props.dsc.isMobileLandscape) ? "": "" }`}>
            <video
              ref={vc.setRefVideo}
              preload="metadata"
              width={videoHeigth * r}
              className={`rounded-lg m-auto`}
              muted={true}
              controls={false}
              onPlay={() => { vc.setIsPlaying(true) }}
              onEnded={() => { vc.setIsPlaying(false) }}
            >
              <source src={appVideos.app_promo} type="video/mp4" />
              Your browser does not support the video tag.
              
            </video>

            <div
              key={vc.video?.muted.toString()}
              className={`absolute right-0 top-0 h-full w-full transition duration-500 hover:scale-110`}
            >
              {vc.counter >= 1 && !vc.isPlaying ? AppSVGStore.getPlay({
                size: ["100%", "100%"],
                onClick: () => {
                  try {
                    vc.video!!.muted = false;
                    vc.video!!.play();
                  } catch (e) { }
                }
              }) : <></>}
              {vc.counter == 0 && vc.isMuted ? AppSVGStore.getUnMuteButton({
                size: ["100%", "100%"], t: [0, 0],
                onClick: () => {
                  try {
                    vc.video!!.muted = false;
                    vc.setIsMuted(vc.video!!.muted)
                  } catch (e) { }
                }
              }) : <></>}
            </div>
          </div>
        </div>
      </div>

      <div>
        {t(ELng.android_app_error.valueOf())}
      </div>

      <div className={`w-full gap-4 flex overflow-visible whitespace-nowrap mt-4 ${props.dsc.medium ? "flex-col" : "flex-col"}`}>
         
        {props.ef.getButtonType1({
          classNameFrame: props.dsc.medium?"w-full":"w-[30rem]",
          classNameBaseFrame: "",
          classNameInput: CommonCSSSerivce.buttonwhite + " "+AppCSSService.onItemHover + " w-full",
          caption: () => <>
            <div className="flex items-center">
              <div className="p-2 flex flex-row">
                <div className={'pr-2'}>
                  {AppSVGStore.getGooglePlay({ size: 42 })}
                </div>
                <div className="flex flex-col items-start text-black">
                  <div className={`text-black text-medium`}>{t(ELng.android_app_googleplay_header.valueOf())}</div>
                  <div className="flex flex-row w-full">
                    <div className={`text-xl font-bold`}>{t(ELng.android_app_googleplay_desc.valueOf())}</div>
                    <p className={`p-1 ml-4 pt-1 text-s`}>{`v.${Globals.wohVersion}`}</p>
                  </div>
                </div>
              </div>
            </div>
          </>,
          f: () => {
            window.open(Globals.webPlayStore, "blank")
           }
        })}

        {/* ServerAPKButton */}
        {props.ef.getButtonType1({
          classNameFrame: props.dsc.medium?"w-full":"w-[30rem]",
          classNameBaseFrame: "",
          classNameInput: CommonCSSSerivce.buttonwhite + " "+AppCSSService.onItemHover + " w-full",
          caption: () => <>
            <a href={Globals.baseWebUrl + files.wohfree} download>
              <div className="flex items-center">
                <div className="pt-2 pb-2 flex flex-row">
                  <img className={"w-[3rem] h-[3rem]"} src={images.logoFree} />
                  <div className="flex flex-col items-start pl-2">
                    <div className={"text-black text-medium"}>{t(ELng.android_app_woh_header.valueOf())}</div>
                    <div className="flex flex-row w-full">
                    <div className={"text-black text-xl font-bold"}>{t(ELng.android_app_woh_desc.valueOf())}</div>
                      <p className={`p-1 ml-4 pt-1 text-s`}>{`v.${Globals.wohVersion}`}</p>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </>,
          //f: () => { }
        })}
       
      </div>
    </div>
  </CardWrapper>
  )
}